import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { taxZoneInitialsForAdd, taxZoneInitialsForUpdate } from './interfaces/taxZoneClass';
import { addTaxZoneAsync, updateTaxZoneAsync, resetSelectedRecordObjectInState } from './taxZoneSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';
const TaxZoneForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
     const { t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(taxZoneInitialsForAdd);
    const { selectedRecord,taxZoneList, isLoading } = useAppSelector((state) => state.taxZone);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {

            const tempObj: any = selectedRecord;
            Object.keys(taxZoneInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(taxZoneInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
 
    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateTaxZoneAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Tax Zone Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        else {
            dispatch(addTaxZoneAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Tax Zone Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (taxZoneList.length > 0) {
            let index = 0;
            taxZoneList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(taxZoneList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AccountTaxZone: yup
                        .string()
                        .label('AccountTaxZone')
                        .trim()
                        .required
                        // (t('Tax zone field is required'))
                        (getValueFromResource('Tax zone field is required',dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                                    // t('Update Tax Zone') 
                                                    getValueFromResource('Update Tax Zone',dispatch, t)  : 
                                                    // t('Add Tax Zone')} 
                                                    getValueFromResource('Add Tax Zone',dispatch, t)}

                                                     </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="modal-body">

                                                    <div className="mb-0">
                                                        <label className="fs-7 fs-7 fw-normal mb-2">
                                                            {/* {t('Tax Zone')} */}
                                                            {getValueFromResource('Tax Zone',dispatch, t)}
                                                            </label>
                                                        <input type="text" className="form-control fs-7 fw-normal mb-2"  id='AccountTaxZone' value={values.AccountTaxZone} name='AccountTaxZone'
                                                            onChange={handleChange('AccountTaxZone')}
                                                            style={{ color: '#172b4d' }}
                                                            ref={defaultFocusRef}
                                                        />
                                                    </div>
                                                    <div style={{ paddingRight: 5 }}>
                                                        {touched.AccountTaxZone && errors.AccountTaxZone &&
                                                            <p className='errorMsg'>{errors.AccountTaxZone as string}</p>
                                                        }
                                                    </div>
                                                    {Object.keys(selectedRecord).length > 0 ? (
                                                                    disabledCount !== 1 ? <div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}

                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div> : taxZoneList.find(x => x.AccountTaxZoneId === values.AccountTaxZoneId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div>)
                                                                ) : null}
                                                </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel',dispatch, t)}
                                                    </button>
                                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                    {/* {t('Save')}   */}
                                                    {getValueFromResource('Save',dispatch, t)}

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>

    )
}

export default TaxZoneForm